if(!customElements.get("carousel-component")) {
  class Carousel extends HTMLElement {
    constructor() {
      super();
      this.carouselElement = this;
  
      this.desktopPerPage = parseInt(this.carouselElement.dataset['desktopperpage']) || parseInt(this.carouselElement.dataset['desktopPerPage']) || 4;
      this.mobilePerPage = parseInt(this.carouselElement.dataset['mobileperpage']) || parseInt(this.carouselElement.dataset['mobilePerPage']) || 1;
      this.desktopPerMove = parseInt(this.carouselElement.dataset['desktoppermove']) || parseInt(this.carouselElement.dataset['desktopPerMove']) || 1;
      this.mobilePerMove = parseInt(this.carouselElement.dataset['mobilepermove']) || parseInt(this.carouselElement.dataset['mobilePerMove']) || 1;
      this.tabletPerMove = parseInt(this.carouselElement.dataset['tabletpermove']) || parseInt(this.carouselElement.dataset['tabletPerMove']) || this.desktopPerMove || 1;
      this.focus = this.carouselElement.dataset['focus'];
      this.type = this.carouselElement.dataset['type'];
      this.gap = this.carouselElement.dataset['gapbetweenslides'] || 0;
      this.gapMobile = this.carouselElement.dataset['gapbetweenslidesonmobile'] || 0;
      this.autoplaySpeed = parseInt(this.dataset['autoplaySpeed']) || 3000;
      this.direction = this.carouselElement.dataset['direction'] || 'ltr';
      this.mobilePaddingLeft = this.carouselElement.dataset['mobilepaddingleft'] || '0';
      this.mobilePaddingRight = this.carouselElement.dataset['mobilepaddingright'] || '0';
      this.desktopPaddingLeft = this.carouselElement.dataset['desktoppaddingleft'] || '0';
      this.desktopPaddingRight = this.carouselElement.dataset['desktoppaddingright'] || '0';
      this.mobileFixedWidth = this.carouselElement.dataset['mobilefixedwidth'];
      this.desktopFixedWidth = this.carouselElement.dataset['desktopfixedwidth'];
  
      // Data attribute string matching for correct boolean value
      // The fallback is used if the developer make mistake the code is forgiving
      // Read more here https://stackoverflow.com/questions/263965/how-can-i-convert-a-string-to-boolean-in-javascript
      this.showarrows = this.carouselElement.dataset['showarrows'] === 'true' || false;
      this.autoplay = this.carouselElement.dataset['autoplay'] === 'true' || false;
      this.showarrowsonmobile = this.carouselElement.dataset['showarrowsonmobile'] === 'true' || false;
      this.showdots = this.carouselElement.dataset['showdots'] === 'true' || false;
      this.showdotsonmobile = this.carouselElement.dataset['showdotsonmobile'] === 'true' || false;
      this.isNavigation = this.carouselElement.dataset['isnavigation'] === 'true' || false;
      this.disableDrag = this.carouselElement.dataset['disabledrag'] === 'true' || false;
      this.destroyOnMobile = this.carouselElement.dataset['enableonmobile'] == 'false' || false;
      this.destroyOnDesktop = this.carouselElement.dataset['enableondesktop'] == 'false' || false;
      this.omitEnd = this.carouselElement.dataset['omitEnd'] == 'false' || false;

      this.tabletPerPage = this.carouselElement.dataset['tabletperpage'] ? parseInt(this.carouselElement.dataset['tabletperpage']) : null;
      this.loop = this.carouselElement.dataset['loop'] === 'true';
      this.loopSet = this.carouselElement.dataset['loop'] !== undefined;
      this.pauseOnHover = this.carouselElement.dataset['pauseonhover'] === 'true';
      this.pauseOnHoverSet = this.carouselElement.dataset['pauseonhover'] !== undefined;
      this.speed = this.carouselElement.dataset['speed'] ? parseInt(this.carouselElement.dataset['speed']) : null;
      this.dragEnabled = this.carouselElement.dataset['drag'] === 'true';
      this.dragSet = this.carouselElement.dataset['drag'] !== undefined;
      this.freeDrag = this.carouselElement.dataset['freedrag'] === 'true';
      this.freeDragSet = this.carouselElement.dataset['freedrag'] !== undefined;
      this.flickPower = this.carouselElement.dataset['flickpower'] ? parseInt(this.carouselElement.dataset['flickpower']) : 250;
      this.flickPowerMobile = this.carouselElement.dataset['flickpowermobile'] ? parseInt(this.carouselElement.dataset['flickpowermobile']) : 200;
      this.flickMaxPages = this.carouselElement.dataset['flickmaxpages'] ? parseFloat(this.carouselElement.dataset['flickmaxpages']) : (this.desktopPerMove === 1 ? 0.25 : 1);
      this.flickMaxPagesMobile = this.carouselElement.dataset['flickmaxpagesmobile'] ? parseFloat(this.carouselElement.dataset['flickmaxpagesmobile']) : (this.mobilePerMove === 1 ? 0.2 : 1);

      // Helper to parse boolean or string values from dataset attributes
      const parseValue = (val) => {
        if (val === 'true') return true;
        if (val === 'false') return false;
        return val;
      };

      this.focus = this.carouselElement.dataset['focus'];
      this.trimSpace = parseValue(this.carouselElement.dataset['trimspace']);
      this.updateOnMove = parseValue(this.carouselElement.dataset['updateonmove']);
      
      this.focusMobile = this.carouselElement.dataset['focusmobile'] || this.focus;
      if (!this.focusMobile && this.mobileFixedWidth && this.mobileFixedWidth !== '100%') {
        this.focusMobile = 'center';
      }
      
      this.trimSpaceMobile = parseValue(this.carouselElement.dataset['trimspacemobile']) || this.trimSpace;
      if (this.trimSpaceMobile === undefined && this.focusMobile === 'center') {
        this.trimSpaceMobile = 'move';
      }

      this.focusTablet = this.carouselElement.dataset['focustablet'] || this.focus;
      this.trimSpaceTablet = parseValue(this.carouselElement.dataset['trimspacetablet']) || this.trimSpace;

      this.refresh = this.carouselElement.dataset['refresh'] == 'true' || false;
      this.sync = this.carouselElement.dataset['carouselsyncselector'] || false;
  
      // Carousel element should have class splide
      if (!this.carouselElement.classList.contains('splide')) return;
  
      this.initCarousel();
    }
   
    initCarousel() {
      if (this.destroyOnMobile && this.destroyOnDesktop) return;

      // Determine drag value
      let dragVal = !this.disableDrag;
      if (this.dragSet) {
        dragVal = this.dragEnabled;
      }
      if (this.freeDragSet && this.freeDrag) {
        dragVal = 'free';
      }

      // Build desktop configuration
      const desktopConfig = {
        ...(this.type ? { type: this.type } : {}),
        ...(this.loopSet ? { type: this.loop ? 'loop' : 'slide' } : {}),
        ...(this.focus ? { focus: this.focus } : {}),
        ...(this.trimSpace !== undefined ? { trimSpace: this.trimSpace } : {}),
        ...(this.updateOnMove !== undefined ? { updateOnMove: this.updateOnMove } : {}),
        autoplay: this.autoplay,
        interval: this.autoplaySpeed,
        gap: this.gap,
        arrows: this.showarrows,
        pagination: this.showdots,
        isNavigation: this.isNavigation,
        drag: dragVal,
        direction: this.direction,
        destroy: this.destroyOnDesktop,
        padding: { left: this.desktopPaddingLeft, right: this.desktopPaddingRight },
        omitEnd: this.omitEnd,
        perMove: this.desktopPerMove || 1,
        flickPower: this.flickPower,
        flickMaxPages: this.flickMaxPages,
        ...(this.speed ? { speed: this.speed } : {}),
        ...(this.pauseOnHoverSet ? { pauseOnHover: this.pauseOnHover } : {})
      };

      // Only add perPage if desktopFixedWidth is not set
      if (!this.desktopFixedWidth) {
        desktopConfig.perPage = this.desktopPerPage;
      } else {
        desktopConfig.fixedWidth = this.desktopFixedWidth;
      }

      // Build mobile breakpoint configuration
      const mobileBreakpointConfig = {
        padding: { left: this.mobilePaddingLeft, right: this.mobilePaddingRight },
        arrows: this.showarrowsonmobile,
        pagination: this.showdotsonmobile,
        gap: this.gapMobile,
        destroy: this.destroyOnMobile,
        perMove: this.mobilePerMove || 1,
        speed: this.speed || 400,
        dragMinThreshold: 10,
        flickPower: this.flickPowerMobile,
        flickMaxPages: this.flickMaxPagesMobile,
        drag: dragVal,
        ...(this.focusMobile ? { focus: this.focusMobile } : {}),
        ...(this.trimSpaceMobile !== undefined ? { trimSpace: this.trimSpaceMobile } : {}),
        ...(this.updateOnMove !== undefined ? { updateOnMove: this.updateOnMove } : {}),
        ...(this.pauseOnHoverSet ? { pauseOnHover: this.pauseOnHover } : {})
      };

      // Only add perPage if mobileFixedWidth is not set
      if (!this.mobileFixedWidth) {
        mobileBreakpointConfig.perPage = this.mobilePerPage;
      } else {
        mobileBreakpointConfig.fixedWidth = this.mobileFixedWidth;
      }

      // Build tablet breakpoint configuration (screens between 750px and 1024px)
      const tabletBreakpointConfig = {
        padding: { left: this.desktopPaddingLeft, right: this.desktopPaddingRight },
        arrows: this.showarrows,
        pagination: this.showdots,
        gap: this.gap,
        perMove: this.tabletPerMove || this.desktopPerMove || 1,
        speed: this.speed || 400,
        drag: dragVal,
        flickPower: this.flickPower,
        flickMaxPages: this.flickMaxPages,
        ...(this.focusTablet ? { focus: this.focusTablet } : {}),
        ...(this.trimSpaceTablet !== undefined ? { trimSpace: this.trimSpaceTablet } : {}),
        ...(this.pauseOnHoverSet ? { pauseOnHover: this.pauseOnHover } : {})
      };

      if (this.tabletPerPage) {
        tabletBreakpointConfig.perPage = this.tabletPerPage;
      } else {
        tabletBreakpointConfig.perPage = this.desktopPerPage;
      }

      // More option available here https://splidejs.com/documents/
      // This slider can be customized as require check the above doc before adding any new 
      // Slider library.
      this.carousel = new Splide(this.carouselElement, {
        ...desktopConfig,
        breakpoints: {
          1024: tabletBreakpointConfig,
          750: mobileBreakpointConfig
        },
      });

      let dragStartIndex = 0;
      let isDragging = false;

      this.carousel.on('drag', () => {
        isDragging = true;
        dragStartIndex = this.carousel.index;
      });

      this.carousel.on('move', (newIndex) => {
        if (isDragging) {
          isDragging = false;
          const isMobile = window.innerWidth < 750;
          const perMoveSetting = isMobile ? this.mobilePerMove : this.desktopPerMove;
          if (perMoveSetting === 1) {
            const total = this.carousel.length;
            let diff = newIndex - dragStartIndex;
            if (this.carousel.is('loop')) {
              if (diff > total / 2) diff -= total;
              if (diff < -total / 2) diff += total;
            }
            if (Math.abs(diff) > 1) {
              const target = this.carousel.is('loop')
                ? (dragStartIndex + Math.sign(diff) + total) % total
                : Math.max(0, Math.min(total - 1, dragStartIndex + Math.sign(diff)));
              
              if (target !== newIndex) {
                setTimeout(() => {
                  if (this.carousel && this.carousel.index !== target) {
                    this.carousel.go(target);
                  }
                }, 0);
              }
            }
          }
        }
      });
  
      if (this.sync) {
        this.initProgressBar(this.carousel);
        this.initCarouselSync();
        this.carousel.refresh();
      } else {
        this.initProgressBar(this.carousel);
        this.carousel.mount();

        if (this.refresh) {
          this.carousel.refresh();
        }
      }

      this.ensureFirstLoadRefresh();
    }

    ensureFirstLoadRefresh() {
      requestAnimationFrame(() => {
        if (this.carousel) this.carousel.refresh();
      });
      setTimeout(() => {
        if (this.carousel) this.carousel.refresh();
      }, 50);
      setTimeout(() => {
        if (this.carousel) this.carousel.refresh();
      }, 200);
    }

    connectedCallback() {
      this.ensureFirstLoadRefresh();
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting && this.carousel) {
              this.carousel.refresh();
              observer.unobserve(this);
            }
          });
        }, { rootMargin: '50px' });
        observer.observe(this);
      }
      window.addEventListener('load', () => {
        if (this.carousel) this.carousel.refresh();
      }, { once: true });
    }

    initProgressBar(skeletonSplide) {
      const bar = this.querySelector('.my-slider-progress-bar');

      if(!bar) return;

      this.carousel.on( 'mounted move', function () {
          var end  = skeletonSplide.Components.Controller.getEnd() + 1;
          var rate = Math.min(( skeletonSplide.index + 1 ) / end, 1 );
          bar.style.width = String( 100 * rate ) + '%';
        });
    }
  
    initCarouselSync() {
      this.syncElement = document.querySelector(this.sync);
      this.direction = this.syncElement.dataset['direction'] || 'ltr'
  
      this.carouselSync = new Splide(this.sync, {
        updateOnMove: true,
        perPage: this.syncElement.dataset['desktopperpage'] || 5,
        type: this.syncElement.dataset['type'] || 'loop',
        focus: this.syncElement.dataset['focus'] || 'center',
        isNavigation: this.syncElement.dataset['isnavigation'] === 'true' || false,
        pagination: false,
        gap:"1.2rem",
        arrows: this.syncElement.dataset['showarrows'] === 'true' || false,
        drag: true,
        // Conditional configuration for 'ttb' direction
        ...(this.direction === 'ttb' && {
          height: this.getPrimarySlideFirstImageHeight(),
          direction: 'ttb',
          autoHeight: true,
        }),
        breakpoints: {
          767: {
            height: 'auto',
            direction: 'ltr',
            gap: this.gapMobile
          }
        },
      });
      
  
      this.carousel.sync(this.carouselSync);
      this.carousel.mount();
      this.carouselSync.mount();
    };
  
    refreshSlider() {
      this.carousel.refresh();
      if (this.carouselSync) {
        this.carouselSync.refresh();
      }
    }

    getPrimarySlideFirstImageHeight() {
      const image = this.querySelector('.splide__list img');
      const containerWidth = this.querySelector('.splide__list').clientWidth;
  
      // Get the original width and height of the image
      const originalWidth = image.getAttribute('width');
      const originalHeight = image.getAttribute('height');
  
      // Calculate the scaled height to fit within the container
      return (containerWidth / originalWidth) * originalHeight;
    }
  }

  // Exposing the Carousel class globally to allow other custom elements, like the product-form, to extend its functionality.
  window.Carousel = Carousel;
  customElements.define('carousel-component', Carousel);
}